<template>
  <el-dialog :visible.sync="visible" :show-close="false" width="410px" class="sign-up-chinese">
    <div class="entry-header">
      <div class="entry-header-wrap">
				<div class="entry-header-wrap-title">
					会员活动报名
				</div>
				<div class="entry-header-wrap-tip">
					请填写真实有效信息
				</div>
			</div>
    </div>
    <div class="entry-content">
      <el-form :model="subForm" :rules="rules" ref="subForm" label-position="right" class="sign-up-form">
        <el-form-item label="姓名" prop="name" label-width="65px">
          <el-input v-model="subForm.name" placeholder="请输入您的姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="机构" prop="company" label-width="65px">
          <el-input v-model="subForm.company" placeholder="请输入您的机构名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="职务" prop="duties" label-width="65px">
          <el-input v-model="subForm.duties" placeholder="请输入您的职务" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="mobile" label-width="65px">
          <el-input v-model="subForm.mobile" placeholder="您的手机号" clearable>
            <el-select v-model.trim="tempPrefix" slot="prepend" placeholder="区号" @change="prefixChange">
              <el-option v-for="(item, index) in mobileList" :label="item.label" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="E-mail" prop="email" label-width="65px">
          <el-input v-model.trim="subForm.email" placeholder="请输入您的联系邮箱" clearable></el-input>
        </el-form-item>
        <el-form-item prop="survey_content" v-if="activityInfo.survey_name">
          <div>
            <span>{{ activityInfo.survey_name }}</span>
          </div>
          <el-input v-model="subForm.survey_content" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" :maxlength="140" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="entry-footer">
      <div class="entry-footer-logo">
				<img src="~@/assets/chinese_logo.png" alt="CF40 研究" />
			</div>
			<div class="entry-footer-btn">
        <el-button type="danger" :loading="subLoading" @click="saveForm" style="width: 30%">提 交</el-button>
			</div>
    </div>
    <div class="entry-close">
      <i class="el-icon-circle-close" @click="closeSignUp"></i>
    </div>
  </el-dialog>
</template>
<script>
import { activityMobileRegs, entryActivity } from '@/api';
export default {
  name: "SignUpChinese",
  data() {
    return {
      visible: false,
      subLoading: false,
      rules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
        ],
        company: [
          { required: true, message: '请输入您的机构名称', trigger: 'blur' },
        ],
        duties: [
          { required: true, message: '请输入您的职务', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: '请输入您的手机号', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入您的联系邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      subForm: {},
      tempPrefix: null,
      mobileList: [],
      mobileInfo: {},
      activityInfo: {},
    }
  },
  methods: {
    // 打开报名窗口
    async openSignUp (row) {
      if (row && row.id) {
        this.activityInfo = row;
        this.resetSubForm();
        await this.getMobileRegs();
        this.visible = true
      }
    },
    // 关闭报名窗口
    closeSignUp () {
      this.visible = false;
    },
    resetSubForm () {
      this.subForm = {}
      this.mobileInfo = { id: null }
    },
    async getMobileRegs() {
      let res = await activityMobileRegs();
      if (res && res.code == 200) {
        this.mobileList = [];
        if (res.data && res.data.length > 0) {
          let arr = [];
          for (let i = 0; i < res.data.length; i++) {
            let item = res.data[i];
            item['label'] = `${item.name}(${item.prefix ? item.prefix : '+86'})`
            arr.push(item);
          }
          this.mobileInfo = arr[0];
          this.tempPrefix = this.mobileInfo.id;
          this.rules.mobile.push({ pattern: new RegExp(this.mobileInfo.reg), message: '手机号格式不正确', trigger: 'blur' });
          this.mobileList = arr;
        }
      }
    },
    prefixChange(e) {
      if (this.mobileList && this.mobileList.length > 0) {
        for (let i = 0; i < this.mobileList.length; i++) {
          let item = this.mobileList[i];
          if (item.id == e) {
            this.mobileInfo = item;
            this.rules.mobile.splice(1, 1, { pattern: new RegExp(item.reg), message: '手机号格式不正确', trigger: 'blur' });
            break;
          }
        }
      }
      this.$refs.subForm.validateField('mobile');
    },
    createForm() {
      let temps = {
        activity_id: this.activityInfo.id,
        name: this.subForm.name.replace(/\s/g, ''),
        company: this.subForm.company.replace(/\s/g, ''),
        duties: this.subForm.duties.replace(/\s/g, ''),
        email: this.subForm.email.replace(/\s/g, ''),
        mobile: `${this.mobileInfo.prefix ? this.mobileInfo.prefix +'-'+ this.subForm.mobile.replace(/\s/g, '') : this.subForm.mobile.replace(/\s/g, '')}`,
      };
      if (this.activityInfo.survey_name && this.subForm.survey_content) {
        temps['survey_content'] = this.subForm.survey_content.replace(/\s/g, '');
      }
      return temps;
    },
    async signUpActivity() {
      this.subLoading = true;
      let res = await entryActivity(this.createForm());
      if (res && res.code == 200) {
        this.$message.success({
          message: res && res.msg ? res.msg : "操作成功！"
        });
        this.closeSignUp();
        this.$emit("callback");
      }
      this.subLoading = false;
    },
    saveForm() {
      this.$refs.subForm.validate((valid) => {
        if (valid) {
          this.signUpActivity();
        }
      });
    }
  }
}
</script>
<style scoped lang="scss">
.sign-up-chinese {
  .entry-header {
    &-wrap {
      color: #ffffff;
      padding: 25px 0 25px 30px;
      background-color: #dd7643;
      &-title {
        font-size: 22px;
        font-weight: 700;
      }
      &-tip {
        margin-top: 10px;
        font-size: 12px;
      }
    }
  }
  .entry-content {
    padding: 25px 15px 0 15px;
  }
  .entry-footer {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #ffffff;
		&-logo {
			width: 120px;
		}
		&-btn {
			width: 260px;
		}
  }
  .entry-close {
    position: absolute;
    bottom: -40px;
    right: 50%;
    left: 50%;
    i {
      font-size: 26px;
      color: #ffffff;
      font-weight: bolder;
      cursor: pointer;
      &:hover {
        color: #dd7643
      }
    }
  }
  ::v-deep {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus,
    .el-textarea__inner:focus{
      border-color: #ED6F33
    }
    .el-select .el-input {
      width: 150px;
    }
    .el-input-group__append, .el-input-group__prepend {
      background-color: #fff;
    }
    .el-button--danger {
      border-color: #dd7643;
      background-color: #dd7643;
      &:hover {
        border-color: #ED966A;
        background-color: #ED966A;
      }
      &:active {
        border-color: #ED6F33;
        background-color: #ED6F33;
      }
    }
  }
}
</style>
